export const VITE_APP_NAME = import.meta.env.VITE_APP_NAME || "Qalibr";
export const VITE_ENV = import.meta.env.VITE_ENV || "development";
export const VITE_WEBSITE_DOMAIN = import.meta.env.VITE_WEBSITE_DOMAIN || "http://localhost:5173";
export const VITE_API_DOMAIN = import.meta.env.VITE_API_DOMAIN || "http://localhost:8001";
export const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";
